import { WindowRef } from '@abovo/shared-angular-utils';
import { Injectable } from '@angular/core';
import { DataLayerEventActions, DataLayerEventCategories, DataLayerEventTypes, GaEvent, VirtualPageView } from '../constants';

@Injectable()
export class DataLayerService {
   /**
    * Datalayer service constructor
    *
    * @param window
    */
   constructor(private window: WindowRef) {}

   /**
    * Register a Google analytics virtual pageview
    *
    * @param virtualPageURL
    * @param virtualPageTitle
    */
   pageView(virtualPageURL: string, virtualPageTitle: string) {
      this.push({
         event: DataLayerEventTypes.DATALAYER_VIRTUAL_PAGE_VIEW,
         virtualPageURL,
         virtualPageTitle,
      });
   }

   /**
    * Register a Google analytics event
    *
    * @param eventCategory
    * @param eventAction
    * @param eventLabel
    * @param eventValue
    */
   event(eventCategory: DataLayerEventCategories, eventAction: DataLayerEventActions, eventLabel: string, eventValue: string | number) {
      this.push({
         event: DataLayerEventTypes.DATALAYER_GA_EVENT,
         eventCategory,
         eventAction,
         eventLabel,
         eventValue,
      });
   }

   /**
    * Push given event to the datalayer
    *
    * @param event
    */
   private push(event: VirtualPageView | GaEvent) {
      this.window.dataLayer.push(event);
   }
}
